// extracted by mini-css-extract-plugin
export var cta = "blockReferForm-module--cta--ay8nd";
export var header = "blockReferForm-module--header--ElU9f";
export var content = "blockReferForm-module--content--h4cS4";